import React from 'react'
import getMovieTitle from '../functions/getMovieTitle';
import getBackgroundPosterObj from '../functions/getBackgroundPosterObj';
import CinemaIcon from '../BackgroundFormatItem/CinemaIcon';
import ItemPoster from '../PosterFormatItem/ItemPoster';
import getPerformancesIntervall from '../functions/getPerformancesIntervall';
import getMomentNow from '../functions/getMomentNow';
import getDayKey from '../functions/getDayKey';
import Translation from '../General/Translation';
import sortPerformancesByDate from '../functions/sortPerformancesByDate';
import getMomentDateObj from '../functions/getMomentDateObj';
import isCurrentPerformance from '../functions/isCurrentPerformance';
import getTranslationTime from '../functions/getTranslationTime';
import seperateAttributes from '../functions/seperateAttributes';
import getBluePrices from '../functions/getBluePrices';
import ItemAttributesContainer from '../PosterFormatItem/ItemAttributesContainer';

const PageOverviewSignageMovie = ({
    itemData, 
    translation, 
    isMobile=false, 
    filteredPerformaces,
    queryStringValues,
    today,
    currentCinema,
    cinemas,
}) => {
    const { images, technologyAttributes, pk } = itemData
    const { timezone } = translation
    const dateNow = getMomentNow(timezone)
    const keyToday = getDayKey(dateNow)
    const poster = getBackgroundPosterObj(images)
    const currentTitle = getMovieTitle(itemData)
    const periodesDays = getPerformancesIntervall(filteredPerformaces, today, timezone)
    const noEmptyDays = _.omit(periodesDays, function(value) {
        return _.isEmpty(value);
    })
    const noEmptyDaysKeys = _.keys(noEmptyDays)
    const bluePricesClass = getBluePrices(technologyAttributes)

    return (
        <div className={'poster-format-item-wrapper cursor-pointer'}>    
            <div className={"poster-format-item" + bluePricesClass}>       
                <div className={"picture-wrapper theme-radius-posters-top " + pk}>
                    <ItemPoster
                        title={currentTitle} 
                        poster={poster} 
                        isMobile={isMobile}
                        onClick={() => {}}
                        translation={translation}
                    />
                </div>
                <div className={'horizontal-flex-wrapper theme-radius-posters-bottom'}>
                    <div className="performance-items-wrapper theme-radius-posters-bottom">
                        {noEmptyDaysKeys.length !== 0 && noEmptyDaysKeys.map((keyDay, index) => {
                            const dayDateFormarted = getTranslationTime('performanceDates', translation, keyDay)
                            const currentDayFormarted = keyToday === keyDay ? <Translation id="today" trans={translation}>Heute</Translation> : dayDateFormarted
                            const onlyOneDayActiveClass = (queryStringValues && queryStringValues.time && (queryStringValues.time === 'today' || queryStringValues.time === 'tomorrow')) ? ' one-day' : ''
                            const filteredPerformances = noEmptyDays[keyDay] && noEmptyDays[keyDay].filter(perf => {
                                const perfDate = getMomentDateObj(perf.timeUtc, timezone)
                        
                                if(keyDay === getDayKey(perfDate) && isCurrentPerformance(dateNow, perfDate)) {
                                    return perf
                                }
                            })
                        
                            sortPerformancesByDate(filteredPerformances)

                            return (
                                <div className={"performance-item-wrapper" + onlyOneDayActiveClass} key={index}>
                                    {!(queryStringValues && queryStringValues.time && (queryStringValues.time === 'today' || queryStringValues.time === 'tomorrow')) && <div className="performance-item-date text-medium">{currentDayFormarted}</div>}
                                    {filteredPerformances && filteredPerformances.map((performance, index) => {
                                        const { timeUtc, attributes, cinema, theatreName } = performance
                                        const {technologyAttributesWithIcons} = seperateAttributes(attributes)
                                        const showCinemaIcon = (queryStringValues.cinema && queryStringValues.cinema !== cinema) ? true : (!queryStringValues.cinema && currentCinema && currentCinema.pk !== cinema) ? true : false
                                        const showTime = getTranslationTime('showtimePerformance', translation, timeUtc)
                                        
                                        return <div className={"performance-item-showtime theme-radius-posters-full" + bluePricesClass} key={index}>
                                        <div className="showtime text-xlarge-bold">
                                            {showTime}
                                        </div>
                                        <div className='performance-information'>
                                            <p className='theater-name'>{theatreName}</p>
                                            {technologyAttributesWithIcons.length !== 0 && <div className='attributes-with-icons'>
                                                <ItemAttributesContainer attributes={technologyAttributesWithIcons} canBeColored={true} />
                                            </div>}
                                            {showCinemaIcon && <div className='cinemas-icon-wrapper'>
                                                <CinemaIcon cinemaData={cinemas[cinema]}/>
                                            </div>}
                                        </div>  
                                    </div>
                                    })}
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}


export default PageOverviewSignageMovie